import { DEFAULT_PALETTE } from '../../core/palette';
import type { ParamSchema, SchemaValues } from '../../core/params/types';

export const EROSION_PARAMS = [
  {
    kind: 'enum',
    key: 'mode',
    label: 'Modus',
    default: 'deposit',
    segmented: true,
    group: 'Erosion',
    options: [
      { value: 'erode', label: 'Text erodiert' },
      { value: 'deposit', label: 'Sand lagert an' },
    ],
  },
  {
    kind: 'int',
    key: 'grains',
    label: 'Sandkörner',
    min: 500,
    max: 400000,
    step: 100,
    scale: 'log',
    // Below the cell count on purpose: more grains than cells simply fills the canvas
    // as a flat mass instead of building piles against the letterforms.
    default: 16000,
    bulkRange: [6000, 60000],
    group: 'Erosion',
  },
  {
    kind: 'float',
    key: 'cell',
    label: 'Korngrösse',
    min: 1,
    max: 20,
    step: 0.5,
    default: 4,
    unit: 'px',
    group: 'Erosion',
  },
  {
    kind: 'float',
    key: 'direction',
    label: 'Fallrichtung',
    min: -180,
    max: 180,
    step: 1,
    default: 90,
    unit: '°',
    group: 'Erosion',
    tooltip: '90° ist senkrecht nach unten.',
  },
  {
    kind: 'float',
    key: 'spread',
    label: 'Streuung',
    min: 0,
    max: 1,
    step: 0.01,
    default: 0.42,
    group: 'Erosion',
    tooltip: 'Wie stark Körner seitlich abrutschen — bestimmt den Böschungswinkel.',
  },
  {
    kind: 'float',
    key: 'stickiness',
    label: 'Haftwahrscheinlichkeit',
    min: 0.02,
    max: 1,
    step: 0.01,
    default: 0.55,
    group: 'Erosion',
  },
  {
    kind: 'int',
    key: 'maxFall',
    label: 'Max. Fallstrecke',
    min: 4,
    max: 600,
    step: 2,
    default: 220,
    unit: 'Zellen',
    neverRandomise: true,
    group: 'Erosion',
  },

  {
    kind: 'float',
    key: 'opacity',
    label: 'Deckkraft',
    min: 0.05,
    max: 1,
    step: 0.01,
    default: 0.95,
    group: 'Darstellung',
  },
  {
    kind: 'enum',
    key: 'colorMode',
    label: 'Farbmodus',
    default: 'height',
    group: 'Darstellung',
    options: [
      { value: 'solid', label: 'Einfarbig' },
      { value: 'height', label: 'Nach Stapelhöhe' },
      { value: 'time', label: 'Nach Ablagerungszeit' },
    ],
  },
  {
    kind: 'palette',
    key: 'palette',
    label: 'Palette',
    default: { ...DEFAULT_PALETTE, paletteId: 'earth' },
    group: 'Darstellung',
  },
] as const satisfies ParamSchema;

export type ErosionValues = SchemaValues<typeof EROSION_PARAMS>;
